<template>
  <div
    class="site_button"
    :class="[theme, type]"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
    ref="site_button"
  >
    <div class="icon">
      <svg
        v-if="type === 'close'"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.707031 23.334L23.3344 0.706568"
          stroke="#27363C"
          stroke-width="2"
        />
        <path
          d="M0.707031 0.707031L23.3344 23.3344"
          stroke="#27363C"
          stroke-width="2"
        />
      </svg>

      <svg
        v-if="type === 'open'"
        width="24"
        height="19"
        viewBox="0 0 24 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24 16.208V18.3604H0V16.208H24ZM24 10.1914H0V8.03906H24V10.1914ZM24 2.15234H0V0H24V2.15234Z"
          fill="#27363C"
        />
      </svg>

      <!-- <svg
				
				xmlns="http://www.w3.org/2000/svg"
				width="37"
				height="26"
				viewBox="0 0 37 26"
			>
				<g
					id="Hamburger"
					transform="translate(0 1)"
				>
				<line
						id="Line_3"
						data-name="Line 3"
						x2="37"
						transform="translate(0 24)"
						fill="none"
						stroke="#ddfc70"
						stroke-width="3"
					/>
					<line
						id="Line_2"
						data-name="Line 2"
						x2="37"
						transform="translate(0 12)"
						fill="none"
						stroke="#ddfc70"
						stroke-width="3"
					/>
					<line
						id="Line_1"
						data-name="Line 1"
						x2="37"
						fill="none"
						stroke="#ddfc70"
						stroke-width="3"
					/>
				</g>
			</svg> -->
    </div>
  </div>
</template>

<script>
import Close from '../../images/close_X.svg';
import Open from '../../images/menu.svg';

export default {
  data() {
    return {
      button_label: this.label,
      button_link: this.link,
      hovered: false,
      open: Open,
      close: Close,
    };
  },

  props: {
    label: {},
    theme: {
      default: 'light',
    },
    type: {
      default: 'normal',
    },
  },

  computed: {},

  watch: {
    link() {
      this.button_link = this.link;
    },
  },

  methods: {
    checkEmpty(e) {
      if (this.button_link.url === '#') {
        // this.$refs.site_button.removeAttribute('href');
        e.preventDefault();
      }
    },
  },

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
  display: inline-flex;
  flex-direction: column-reverse;
  transition: 0.2s ease all;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 0;
  background: transparent;
  align-items: center;
  gap: 2px;
  /* width: 40px;
	height: 40px; */

  .scrolled & {
    span {
      color: var(--midnight);
    }

    svg {
      display: flex;
      /* max-width: 24px;
			max-height: 12px; */
      /* margin-left: 8px; */

      &::v-deep {
        line {
          stroke: var(--cobalt);
        }
      }
    }
  }

  @media (hover) {
    &:hover {
      transition: 0.2s ease all;
      cursor: pointer;

      span {
        transition: 0.2s ease all;
      }
    }
  }

  &:disabled {
    opacity: 0.5;
  }

  span {
    font: normal normal 700 12px/14px var(--primary-font-family-heading);
    transition: 0.2s ease all;
    margin-right: 0;
    position: relative;
    z-index: 10;
    color: var(--midnight);
    text-transform: uppercase;
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 23px;
  }

  svg {
    display: flex;
    /* max-width: 24px;
		max-height: 12px;
		margin-left: 8px; */

    &::v-deep {
      line {
        stroke: var(--cobalt);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MenuButton.vue